import { ThisConnector } from '../../../../api/connector'

export async function getRecentApplications(
  this: ThisConnector,
  {
    organizationUuid
  }: {
    organizationUuid: string
  }
) {
  const { applications } = await this.connector.get(
    `${organizationUuid}/applications/activity/recent`
  )

  return applications
}
